"use strict";

$(document).ready(function () {
  if ($('.product-text-block .button').length > 0) {
    $(document).on('click', '.product-text-block .button', function () {
      var thisEl = $(this);
      var mainParent = thisEl.parents('.product-text-block');
      var innerBlock = mainParent.find('.product-text-blockInner');
      var btnBlock = mainParent.find('.product-text-block-button-wrapper');
      innerBlock.addClass('show');
      btnBlock.hide();
    });
  }

  var initPVSliders = function initPVSliders() {
    $('.pv_slider.pv_new_slider').each(function () {
      var thisSlider = $(this);
      var thisPrev = thisSlider.parents('.pv_sliderHolder').find('.pv_sliderHolder__navigation--prev');
      var thisNext = thisSlider.parents('.pv_sliderHolder').find('.pv_sliderHolder__navigation--next');
      new Swiper(thisSlider, {
        loop: false,
        speed: 400,
        slidesPerView: 5,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: thisNext,
          prevEl: thisPrev
        }
      });
      $(this).removeClass('pv_new_slider');
    });
  };

  if ($('.pv_slider.pv_new_slider').length > 0) {
    initPVSliders();
    $(document).on('click', '.pv_slide', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var thisEl = $(this);
      var thisHref = thisEl.attr('data-href');
      window.location.href = thisHref;
    });
  }

  if ($('#js-product-list').length > 0) {
    var target = document.getElementById('js-product-list');
    var observer = new MutationObserver(initPVSliders);
    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }
});